import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import {
  ApiResponse,
  AdImageWithTag,
  CreateAdImage,
  UpdateAdImage,
} from '@magnetar/admin-api-interfaces'

export const adImageService = {
  // 取得供應商的廣告圖片列表
  getAdImages: async (supplierId: number, includeInactive: boolean, token: string) => {
    try {
      const response = await apiClient.get<ApiResponse<AdImageWithTag[]>>(
        `/api/ad-supplier/${supplierId}/ad-images`,
        {
          params: includeInactive ? { includeInactive: true } : undefined,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'GET_AD_IMAGES_FAILED',
          message: '取得廣告圖片列表失敗',
        },
      }
    }
  },

  // 取得單一廣告圖片
  getAdImageById: async (supplierId: number, adImageId: number, token: string) => {
    try {
      const response = await apiClient.get<ApiResponse<AdImageWithTag>>(
        `/api/ad-supplier/${supplierId}/ad-images/${adImageId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'GET_AD_IMAGE_FAILED',
          message: '取得廣告圖片失敗',
        },
      }
    }
  },

  // 新增廣告圖片（需先透過 uploadFileService 上傳檔案取得 file_uuid）
  createAdImage: async (
    supplierId: number,
    data: Omit<CreateAdImage, 'supplier_id'>,
    token: string,
  ) => {
    try {
      const response = await apiClient.post<ApiResponse<AdImageWithTag>>(
        `/api/ad-supplier/${supplierId}/ad-images`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'CREATE_AD_IMAGE_FAILED',
          message: '新增廣告圖片失敗',
        },
      }
    }
  },

  // 更新廣告圖片（標記廣告、播放時長、啟用狀態）
  updateAdImage: async (
    supplierId: number,
    adImageId: number,
    data: UpdateAdImage,
    token: string,
  ) => {
    try {
      const response = await apiClient.put<ApiResponse<AdImageWithTag>>(
        `/api/ad-supplier/${supplierId}/ad-images/${adImageId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'UPDATE_AD_IMAGE_FAILED',
          message: '更新廣告圖片失敗',
        },
      }
    }
  },

  // 刪除廣告圖片（後端會一併刪除底層檔案）
  deleteAdImage: async (supplierId: number, adImageId: number, token: string) => {
    try {
      const response = await apiClient.delete<ApiResponse<void>>(
        `/api/ad-supplier/${supplierId}/ad-images/${adImageId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        error: {
          code: 'DELETE_AD_IMAGE_FAILED',
          message: '刪除廣告圖片失敗',
        },
      }
    }
  },
}
